module.exports = __webpack_public_path__ + "static/media/tick_circle.decb81ee.svg";